import { addIntegration, replayIntegration } from "@sentry/react"

// All of these functions call on requestIdleCallback execution
// Only put functions here that are not critical to the immediate customer experience
// but can be run in the background
const onIdleLoad = () => {
  if (["production", "staging", "dev"].includes(sl.config.env)) {
    addIntegration(
      replayIntegration({
        blockAllMedia: true,
        maskAllInputs: true,
        maskAllText: false,
        networkDetailAllowUrls: [/.*jewlr.*/],
      })
    )
  }
}

export default onIdleLoad
